<app-navbar-container breadcrumb="Hilfe">
  <!-- Changelog is deliberately NOT listed here (#229) — hidden from discovery, not removed.
       The route (`AppRoutes.Changelog` in app.routes.ts) and its component/HTTP service are untouched and stay
       reachable by direct URL, still gated by `Permissions_ChangelogComponent`.

       Removing the entry hides it from the navbar AND from the navbar search in one move: `ItemBase` registers
       each rendered item in `NavbarService.itemBases` (and deregisters it in `ngOnDestroy`), and the office
       navbar's search binds straight to that array — there is no separate search index to update. Pinned by
       navbar-help.component.spec.ts so the two surfaces cannot drift apart again.

       Every entry below wires the SAME call to `(click)` and to `(onSelected)` on purpose: `(click)` is the
       pointer path, `(onSelected)` is the keyboard/navbar-search path (`ItemBase.execute()`, fired by
       navbar-office.component.ts). They are two independent handlers on one entry, so they can silently
       drift — navbar-help.component.spec.ts asserts identical arguments for both.

       `'noopener'` is the third argument everywhere (#255). Unlike `<a target="_blank">`, which implies
       `rel="noopener"` in every current browser, `window.open` does NOT: without it the opened static page
       receives a live `window.opener` handle back into the signed-in SPA and can navigate it. The docs site's
       own contract snippet (StaticPages/docs/DEEPLINKS.md, "How to build a link") already spells it out, and
       carrying it on only one of three identical calls would be the real inconsistency. -->
  <app-navbar-item-large (click)="window.open('/static/legal.html', '_blank', 'noopener')"
                         (onSelected)="window.open('/static/legal.html', '_blank', 'noopener')"
                         [onSelectedFunction]="true"
                         title="Impressum">
    <svg class="h-6 w-6" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 14s1 0 1-1s-1-4-5-4s-5 3-5 4s1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276c.593.69.758 1.457.76 1.72l-.008.002l-.014.002zM11 7a2 2 0 1 0 0-4a2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0a3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904c.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724c.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0a3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>
    </svg>
  </app-navbar-item-large>
  <app-navbar-item-large (click)="window.open('/static/privacy.html', '_blank', 'noopener')"
                         (onSelected)="window.open('/static/privacy.html', '_blank', 'noopener')"
                         [onSelectedFunction]="true"
                         title="Datenschutz">
    <svg class="h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 9.6c-.6 0-1 .4-1 1c0 .4.3.7.6.8l-.3 1.4h1.3l-.3-1.4c.4-.1.6-.4.6-.8c.1-.6-.3-1-.9-1m.1-4.3c-.7 0-1.4.5-1.4 1.2V8h2.7V6.5c-.1-.7-.6-1.2-1.3-1.2M10 2L3 5v3c.1 4.4 2.9 8.3 7 9.9c4.1-1.6 6.9-5.5 7-9.9V5zm4 11c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h.3V6.5C7.4 5.1 8.6 4 10 4c1.4 0 2.6 1.1 2.7 2.5V8h.3c.6 0 1 .4 1 1z"/>
    </svg>
  </app-navbar-item-large>
  <app-navbar-item-large (click)="CookieService.showSettings()"
                         (onSelected)="CookieService.showSettings()"
                         [onSelectedFunction]="true"
                         title="Cookie Einstellungen">
    <svg class="h-6 w-6" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="21" r="2"/>
      <circle cx="23" cy="20" r="2"/>
      <circle cx="13" cy="10" r="2"/>
      <circle cx="14" cy="15" r="1"/>
      <circle cx="23" cy="5" r="2"/>
      <circle cx="29" cy="3" r="1"/>
      <circle cx="16" cy="23" r="1"/>
      <path
        d="M16 30C8.3 30 2 23.7 2 16S8.3 2 16 2h.3l1.4.1l-.3 1.2c-.1.4-.2.9-.2 1.3c0 2.8 2.2 5 5 5c1 0 2-.3 2.9-.9l1.3 1.5c-.4.4-.6.9-.6 1.4c0 1.3 1.3 2.4 2.7 1.9l1.2-.5l.2 1.3c.1.6.1 1.2.1 1.7c0 7.7-6.3 14-14 14m-.7-26C9 4.4 4 9.6 4 16c0 6.6 5.4 12 12 12s12-5.4 12-12v-.4c-2.3.1-4.2-1.7-4.2-4v-.2c-.5.1-1 .2-1.6.2c-3.9 0-7-3.1-7-7c0-.2 0-.4.1-.6"/>
    </svg>
  </app-navbar-item-large>
  <!-- "Anleitung" opens the END-USER documentation site (StaticPages/docs/, Astro Starlight), NOT the retired
       Writerside manual it used to point at (`/static/manual/index.html`, #255).

       The target is the site ROOT, `/static/docs/` — deliberately not a locale or a track. Its
       `src/pages/index.astro` meta-refreshes to `de/`, and the German landing page is the language/track
       chooser ("An der Kasse" vs "Verwaltung"). A navbar entry called "Anleitung" is the generic "show me the
       manual" affordance and has no screen context to derive a track from; the per-screen `?` icons, which do,
       get the deep targets listed in StaticPages/docs/DEEPLINKS.md.

       Root-relative with a trailing slash, per that same contract: the docs are served from `/static/docs` on
       whatever tenant host the reader is already on, so a hostname here would send one tenant's staff to
       another tenant's server. -->
  <app-navbar-item-large (click)="window.open('/static/docs/', '_blank', 'noopener')"
                         (onSelected)="window.open('/static/docs/', '_blank', 'noopener')"
                         [onSelectedFunction]="true"
                         class="ml-auto"
                         title="Anleitung">
    <svg class="h-6 w-6" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <g class="fill-none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5.5 4.054a1.5 1.5 0 1 1 1.5 1.5v.5m0 2.062a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5"/>
        <path
          d="M12.5 13.5H3a1.5 1.5 0 1 1 0-3h8.5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H3a1.5 1.5 0 0 0-1.5 1.46v10m10-1.46v3"/>
      </g>
    </svg>
  </app-navbar-item-large>
</app-navbar-container>
